export default "__VITE_ASSET__C9SZtK0$__"